import { render, staticRenderFns } from "./docPop.vue?vue&type=template&id=68ab2e2c"
import script from "./docPop.vue?vue&type=script&lang=js"
export * from "./docPop.vue?vue&type=script&lang=js"
import style0 from "./docPop.vue?vue&type=style&index=0&id=68ab2e2c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports